import {
  Box,
  FormControlLabel,
  List,
  ListItem,
  ListItemButton,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {ReactComponent as RadioCheckedIcon} from '../../../../assests/svg/radio-checked.svg';
import {ReactComponent as RadioUnCheckedIcon} from '../../../../assests/svg/radio-unchecked.svg';
import {isEmpty} from '../../../../utils/utils';
import {IFieldModal} from '../../field-management/custom-field/constant';
import AurLoadingIndicator from '../../../common/aur-loading-indicator/AurLoadingIndictor';
import {t} from 'i18next';

interface QueryFieldSelectionProps {
  loading: boolean;
  fields?: IFieldModal[];
  onSelectOption?: (option?: IFieldModal) => void;
}

const QueryFieldSelection: React.FC<QueryFieldSelectionProps> = ({
  loading,
  fields,
  onSelectOption,
}) => {
  const [selectedQueryField, setSelectedQueryField] = useState<IFieldModal>();

  useEffect(() => {
    if (!isEmpty(selectedQueryField)) {
      onSelectOption?.(selectedQueryField);
    }
  }, [onSelectOption, selectedQueryField]);

  if (loading) {
    return (
      <Box
        display={'flex'}
        flex={1}
        flexDirection={'column'}
        height={'100%'}
        bgcolor={'#182231'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <AurLoadingIndicator />
      </Box>
    );
  }

  return (
    <Box
      display={'flex'}
      flex={1}
      flexDirection={'column'}
      height={'100%'}
      bgcolor={'#182231'}
      overflow={'auto'}
    >
      <Box className="radio-button-list-container">
        <RadioGroup value={selectedQueryField}>
          <List>
            {fields?.map((item) => (
              <ListItem key={item.fieldId} disablePadding divider>
                <ListItemButton
                  data-testid={`radio-${item.fieldId}`}
                  onClick={() => setSelectedQueryField(item)}
                  sx={{
                    bgcolor:
                      selectedQueryField?.fieldId === item.fieldId
                        ? '#0c1119'
                        : 'transparent',
                  }}
                  aria-label={`${item.fieldLabel} ${
                    selectedQueryField?.fieldId === item.fieldId
                      ? t('indexSearchPage.accessibilityLabel.selected')
                      : t('indexSearchPage.accessibilityLabel.notSelected')
                  }`}
                >
                  <FormControlLabel
                    disabled
                    className={'radio-label'}
                    control={
                      <Radio
                        aria-hidden="true"
                        checkedIcon={
                          selectedQueryField?.fieldId === item.fieldId ? (
                            <RadioCheckedIcon />
                          ) : (
                            <RadioUnCheckedIcon />
                          )
                        }
                      />
                    }
                    label={
                      <Typography
                        aria-hidden="true"
                        className="typo-text body3_size radio-button-label"
                      >
                        {item.fieldLabel}
                      </Typography>
                    }
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </RadioGroup>
      </Box>
    </Box>
  );
};

export default QueryFieldSelection;
